var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "kid_star",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3090_14026",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3090_14026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kid_star_2",
    d: "M5.08301 4.26781L6.94967 1.85114C7.08301 1.67336 7.24134 1.54281 7.42467 1.45947C7.60801 1.37614 7.79967 1.33447 7.99967 1.33447C8.19967 1.33447 8.39134 1.37614 8.57467 1.45947C8.75801 1.54281 8.91634 1.67336 9.04967 1.85114L10.9163 4.26781L13.7497 5.21781C14.0386 5.30669 14.2663 5.47058 14.433 5.70947C14.5997 5.94836 14.683 6.21225 14.683 6.50114C14.683 6.63447 14.6636 6.76781 14.6247 6.90114C14.5858 7.03447 14.5219 7.16225 14.433 7.28447L12.5997 9.88447L12.6663 12.6178C12.6775 13.0067 12.5497 13.3345 12.283 13.6011C12.0163 13.8678 11.7052 14.0011 11.3497 14.0011C11.3275 14.0011 11.2052 13.9845 10.983 13.9511L7.99967 13.1178L5.01634 13.9511C4.96079 13.9734 4.89967 13.9873 4.83301 13.9928C4.76634 13.9984 4.70523 14.0011 4.64967 14.0011C4.29412 14.0011 3.98301 13.8678 3.71634 13.6011C3.44967 13.3345 3.3219 13.0067 3.33301 12.6178L3.39967 9.86781L1.58301 7.28447C1.49412 7.16225 1.43023 7.03447 1.39134 6.90114C1.35245 6.76781 1.33301 6.63447 1.33301 6.50114C1.33301 6.22336 1.41356 5.96503 1.57467 5.72614C1.73579 5.48725 1.96079 5.31781 2.24967 5.21781L5.08301 4.26781Z",
    fill: "#CC0D0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.66b738fe352f01a6bf2bb980d9005645.svg";
export { ForwardRef as ReactComponent };